import { createI18n } from 'vue-i18n';
import { plgPlanSDK, type CreditsPricingDialogOptions } from '../../index';
import { getCurrentLanguage } from '@eureka/language-tool';
import type { PlgPlanSDKOpenOptions, PlgPlanSDKOptions } from '../types';
import { tryOnBeforeMount } from '@vueuse/core';
import { removeAuthToken } from '../utils';
import _ from 'lodash';
import { _passportDeferred } from '@eureka/startup/src/enable-token-base';

export function usePlgPlanSdk(options?: PlgPlanSDKOptions & { router?: any; route?: any }) {
    plgPlanSDK.setI18n(options?.i18n || createI18n({
        locale: getCurrentLanguage(),
        legacy: false,
    }))

    // 处理支付成功回调
    if (options?.router && options?.route) {
        tryOnBeforeMount(async() => {
            const { payment_state } = options.route.query;
            if (payment_state === 'success') {
                removeAuthToken()
                localStorage.removeItem('patsnap_header_account_info')
                try {
                    const _passport = await _passportDeferred.promise;
                    if (!_passport) throw new Error('passport is not setup!')
                    _passport?.removeLocal()
                } catch (error) {
                    console.error('[Use Plg Plan SDK]', 'passport is not setup!')
                }
                console.warn('[Use Plg Plan SDK]', '尝试刷新token')
                plgPlanSDK.openSuccessDialog()
                options.router.replace({
                    query: {
                        ..._.omit(options.route.query, ['payment_state']),
                    },
                })
            }
        })
    }

    /**
     * 打开套餐选择弹窗
     * 在海外环境（us/eu/stage）且为 freemium 用户时，自动使用新的 Credits Pricing Dialog
     */
    async function openPlgPlanDialog(dialogOptions?: PlgPlanSDKOpenOptions) {
        plgPlanSDK.openCreditsPricingDialog({
            successUrl: dialogOptions?.successUrl,
            cancelUrl: dialogOptions?.cancelUrl,
            hideBasic: dialogOptions?.hideBasic,
        });
        // 检查是否应该使用新的 Credits Pricing Dialog
        // const isOversea = ['us', 'eu', 'stage'].includes(REGION);
        // if (isOversea) {
        //     try {
        //         const control = await controlDeferred.promise;
        //         const isFreemium = control?.freemium ?? false;
        //         if (isFreemium) {
        //             // 使用新的 Credits Pricing Dialog
        //             plgPlanSDK.openCreditsPricingDialog({
        //                 successUrl: dialogOptions?.successUrl,
        //                 cancelUrl: dialogOptions?.cancelUrl,
        //                 hideBasic: dialogOptions?.hideBasic,
        //             });
        //             return;
        //         }
        //     } catch (error) {
        //         console.warn('[Use Plg Plan SDK]', 'Failed to check freemium status, fallback to default dialog');
        //     }
        // }
        // 默认使用原有的套餐选择弹窗
        // plgPlanSDK.openPlgPlanDialog(dialogOptions)
    }

    function openCreditsPricingDialog(dialogOptions?: CreditsPricingDialogOptions) {
        plgPlanSDK.openCreditsPricingDialog(dialogOptions)
    }

    function openSuccessDialog() {
        plgPlanSDK.openSuccessDialog()
    }

    return {
        openPlgPlanDialog,
        openCreditsPricingDialog,
        openSuccessDialog,
    }
}
